module.exports = __webpack_public_path__ + "static/media/modalClose.3088a31d.svg";